import { setRemoteDefinitions } from '@nx/angular/mf';

interface Remote {
  __id: string;
  remoteUrl: string;
}

fetch('/assets/glass.manifest.json')
  .then((res) => res.json())
  .then((definitions) => {
    const remotes: Remote[] = definitions.remotes;
    const remoteDefinitions = remotes?.map((remote: Remote) => {
          return {
              [remote.__id]: remote.remoteUrl,
          };
      })
      .reduce((result: any, item: any) => {
        return {
          ...result,
          ...item,
        };
      }, {}) ?? {};

    return setRemoteDefinitions(remoteDefinitions);
  })
  .then(() => import('./bootstrap').catch((err) => console.error(err)));
